import React from 'react';
import PropTypes from 'prop-types';
import Reviewstars from '../../UI/reviewStars/reviewstars';
import CheckboxReview from './TestiReview/checkboxReview';
import './testiOrders.css';

/**
 * Component to display ordered flower products with review options
 * with improved mobile responsiveness
 */
export const TestiOrders = ({ data }) => {
  // Destructure at the component parameter level for clarity
  const { products = [] } = data.data || {}; // Provide default empty array if data or products is undefined

  /**
   * Renders the list of products that were ordered
   * @returns {Array} Array of product row components
   */
  const renderProducts = () => {
    return products.map(product => (
      <div key={product.id} className="products-container">
        <div className="product-image">
          <div className="image-container">
            <img
              className="testi-photo"
              src={product.thumbnail}
              alt={`${product.name} thumbnail`}
              loading="lazy"
            />
          </div>
        </div>
        <div className="product-review">
          <h3 className="product-name">{product.name}</h3>
          <div className="review-options-container">
            <CheckboxReview id={product.id} />
            <Reviewstars id={String(product.id)} />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <section className="testimonial-orders" aria-labelledby="ordered-flowers-title">
      <h2 id="ordered-flowers-title" className="sywfh_r_subtitle">
        List of Flowers Ordered
      </h2>
      <div className="products-list">
        {products && products.length > 0 ? renderProducts() : <p>No products were ordered.</p>}
      </div>
    </section>
  );
};

TestiOrders.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      products: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          name: PropTypes.string.isRequired,
          thumbnail: PropTypes.string.isRequired,
        })
      ),
    }),
  }).isRequired,
};

export default TestiOrders;
